import {
  TListingFetchReason,
  TRESPONSE_BREAKDOWN_REASON_LIST,
  TRESPONSE_EDIT_BREAKDOWN_REASONS_FIELD_DROPDOWN,
  TTablePageInfo,
} from '@monorepo/types';
import { TUserPaginationOption } from '@monorepo/ui';

export type TBreakdownReasonsState = {
  breakdownReasonsListingInfo: {
    res: TRESPONSE_BREAKDOWN_REASON_LIST;
    fetchReason: TListingFetchReason;
  } | null;
  breakdownReasonsDropdown: TRESPONSE_EDIT_BREAKDOWN_REASONS_FIELD_DROPDOWN | null;
  breakdownReasonsPagination: TUserPaginationOption;
};

export const TBreakdownReasonsInfoActionType = {
  GetBreakdownReasonsList: 'GET_BREAKDOWN_REASONS_LIST' as const,
  GetBreakdownReasonsListSuccess: 'GET_BREAKDOWN_REASONS_LIST_SUCCESS' as const,
  GetBreakdownReasonsListFailure: 'GET_BREAKDOWN_REASONS_LIST_FAILURE' as const,
  GetBreakdownReasonsListFilterDropDown: 'BREAKDOWN_REASONS_LIST_FILTER_DROPDOWN' as const,
  GetBreakdownReasonsListFilterDropDownSuccess: 'BREAKDOWN_REASONS_LIST_FILTER_DROPDOWN_SUCCESS' as const,
  GetBreakdownReasonsListFilterDropDownFailure: 'BREAKDOWN_REASONS_LIST_FILTER_DROPDOWN_FAILURE' as const,
  EditBreakdownReasons: 'EDIT_BREAKDOWN_REASONS' as const,
  EditBreakdownReasonsFailure: 'EDIT_BREAKDOWN_REASONS_SUCCESS' as const,
  EditBreakdownReasonsSuccess: 'EDIT_BREAKDOWN_REASONS_FAILURE' as const,
  DeleteBreakdownReasons: 'DELETE_BREAKDOWN_REASONS' as const,
  DeleteBreakdownReasonsSuccess: 'DELETE_BREAKDOWN_REASONS_SUCCESS' as const,
  DeleteBreakdownReasonsFailure: 'DELETE_BREAKDOWN_REASONS_FAILURE' as const,
  SetBreakdownReasonsPagination: 'SET_BREAKDOWN_REASONS_PAGINATION' as const,
};
